﻿import React, { useState, useEffect } from 'react';
import GlobalDialog from '../Modal/GlobalDialog';
import NoteViewer from '../NoteViewer';

import DmaFooter from '../DmaFooter';

import Button from 'devextreme-react/button';
import TextBox from 'devextreme-react/text-box';
import NumberBox from 'devextreme-react/number-box';
import CheckBox from 'devextreme-react/check-box';
import { Tooltip, ITooltipOptions } from 'devextreme-react/tooltip';
import { IPopoverOptions, Popover } from 'devextreme-react/popover';

import { Popup as DialogPopup } from 'devextreme-react/popup';

let key = 0;

export default function InstructionsDemo() {
    const [totalWeight, setTotalWeight] =
        useState<number>();

    const [density, setDensity] =
        useState<number>();

    const [length, setLength] =
        useState<string>();

    const [email, setEmail] =
        useState<string>();

    const [infoId, setInfoId] =
        useState<string>();

    const [showInfo, setShowInfo] =
        useState<boolean>(false);


    useEffect(() => {
        //getAllData();
    }, []);

    return (
        <div className="pw-form-container">
            <div className="lq-title-bar pw-form-header">
                <div className="lq-main-title">Instructions Demo</div>
            </div>

            <div>
                <div className="pw-comp-row">
                    <CheckBox value={showInfo}
                    text="Show Information"
                        onValueChanged={onShowInfoValueChanged} />
                </div>

                <div className="pw-comp-row">
                    <div className="pw-form-unit pw-comp-20">
                        <div className="pw-form-unit-label">Total Weight</div>
                        <NumberBox id="totalWeight"
                            placeholder='NA'
                            value={totalWeight ? totalWeight : undefined}
                            onValueChanged={onTotalWeightValueChanged} />
                    </div>

                    <div className="pw-form-unit pw-comp-20">
                        <div className="pw-form-unit-label">Density</div>
                        <NumberBox id="density"
                            placeholder='NA'
                            value={density ? density : undefined}
                            onValueChanged={onDensityValueChanged} />
                    </div>
                    <i id="density-info" className="dx-icon-info pw-margin-top-1 pw-gray-200" onClick={setShowInfoProps} ></i>
                </div>

                <div className="pw-comp-row">
                    <div className="pw-form-unit pw-comp-20">
                        <TextBox id="length" label="Length" labelMode="floating"
                            placeholder='NA' height="1.6rem"
                            validationStatus="pending"
                            value={length ? length : undefined}
                            onValueChanged={onLengthValueChanged} />
                    </div>
                </div>

                <div className="pw-comp-row">
                    <div className="pw-form-unit pw-comp-40">
                        <TextBox id="email" label="Email" labelMode="floating"
                            placeholder='NA' height="1.6rem"
                            validationStatus="invalid"
                            value={email ? email : undefined}
                            onValueChanged={onEmailValueChanged} />
                    </div>

                </div>
            </div>

            <DmaFooter />

            {showInfo && infoId &&
                <Tooltip
                target={`#${infoId}`}
                    showEvent="mouseenter"
                    hideEvent="mouseleave" 
                    hideOnOutsideClick={false}>
                    <div>Some good information</div>
                </Tooltip>
            }

        </div>
    );

    function onShowInfoValueChanged(e: any) {
       setShowInfo(e.value);
    }

    function onTotalWeightValueChanged(e: any) {
        setTotalWeight(e.value);
    }

    function onDensityValueChanged(e: any) {
        setDensity(e.value);
    }

    function onLengthValueChanged(e: any) {
        setLength(e.value);
    }

    function onEmailValueChanged(e: any) {
        setEmail(e.value);
    }



    function setShowInfoProps(e: any) {
        console.log("showInfo()")
        console.log(e);
        console.log(e.target.id);

        const targetId = "totalWeight";
        setInfoId(targetId)
    }


}
